export default "__VITE_ASSET__DyZ72C5v__"